<style >
.sticky {
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 0px;
}
</style>
<template>
<v-card tile class='mr-2' >
  <a id="top" ></a>
  <v-overlay v-if='req.loading' absolute >
    <center>
      <v-progress-circular color='amber' class='my-4' indeterminate width='2' /><br/>
      loading
    </center>
  </v-overlay>

  <!-- <pre v-text='notification' /> -->
  <!-- <pre v-text='req' /> -->
  <template v-if='notification && notification.slug' >
    <v-toolbar dense flat class='grey lighten-4' >
      <v-btn icon small
        :loading='req.loading' @click='get' >
        <v-icon small >mdi-replay</v-icon></v-btn>
      <v-toolbar-title v-text='notification.name' >
      </v-toolbar-title>
      <v-chip v-if='notification.id' x-small label color='info' class="ml-2" >Customized</v-chip>
      <v-chip v-else >Default</v-chip>
      <v-spacer/>
      <revert-to-default
        v-if='notification.id'
        v-model="notification"
        @reverted="get" />
      <v-btn small class="ml-2"
        @click="setCusomize"
        :disabled="!meId"
        color="primary" >edit notification</v-btn>

    </v-toolbar>
    <v-divider />
    <v-alert dense text
      border="left" type="info" class='caption'
      v-text='notification.description' />

    <v-chip small outlined
      class='ml-2'
      v-if='previewProduct' >
      {{ previewProduct.title }}
      <!-- <v-avatar right >{{previewSettings.product}}</v-avatar> -->
    </v-chip>

    <v-window v-model="window" vertical >
      <v-window-item >
        <v-row >
          <v-col cols=6 >
            <v-card v-if="notification"
              @click="setCusomize"
              class='ml-4 grey lighten-5' >
              <v-card-title class='overline' >
                <v-icon class='mr-2'>mdi-eye</v-icon>
                {{notification.name}}
                <v-spacer />
                <v-chip small outlined label color="info" v-text="notification.type" />
              </v-card-title>

              <template v-if='notification && notification.type === "Email"' >
                <v-subheader class='caption font-weight-bold' >Subject: {{notification.subject}}</v-subheader>
                <v-subheader class='caption font-weight-bold' >Message</v-subheader>
                <v-divider/>
                <!-- eslint-disable-next-line vue/no-v-html -->
                <v-card-text v-html='notification.preview_formatted' />
              </template>
              <template v-if='notification && notification.type === "SMS"' >
                <v-card-text>
                  <v-subheader class='caption font-weight-bold pl-2' >
                    <span class='mr-4' >Message preview</span>
                  </v-subheader>
                  <v-card >
                    <pre
                      class='caption mb-0 pa-3 grey lighten-4 outlined'
                      :class='{"error": notification.has_error}'
                      style='border:solid 1px black;white-space: pre-wrap;'
                      v-text='notification.preview_short' />
                  </v-card>
                </v-card-text>
              </template>
              <p class="caption px-4 info--text" >
                <strong>Note:</strong> Links are for example only, and may not work
              </p>

              <v-alert
                v-if='notification.type === "SMS" && messageLength > 500' type='error' border="top" text tile >
                <strong>This SMS is too long</strong>
                This message is close to the limit of how long a message can be and may fail to send due to being too long.
                Consider shortening the message or sending via Email instead
              </v-alert>
              <v-alert class="mb-0"
                v-else-if='notification.type === "SMS" && messageLength > 160' type='warning' border="top" text tile >
                <strong>This SMS is too long</strong>
                This message contains more than 1 sms (it contains: {{ Math.ceil(messageLength/156) }}).
                Consider shortening the message or sending via Email instead
              </v-alert>
              <v-divider/>
              <v-footer class='caption' >
                <strong v-text='notification.name'/>.
                <v-spacer/>
                <span v-if="notification.type === 'SMS'" >~{{messageLength}} characters</span>
              </v-footer>

            </v-card>
          </v-col>
          <v-col cols=6>
            <v-card outlined tile >
              <v-card-title class='overline' >
                <v-icon class='mr-2'>mdi-cog</v-icon>
                Preview settings
              </v-card-title>
              <preview-settings
                  title='Preview settings'
                  @apply='get'
                  v-model='previewSettings'
                  :space-id='spaceId' />
            </v-card>
          </v-col>
        </v-row>
      </v-window-item >
      <v-window-item >
        <!-- @saved='notificationSaved' -->
        <notification-form
          v-if='notification'
          v-model='notification'
          @saved='notificationSaved' />
      </v-window-item>
    </v-window>

  </template>
  <v-card-text v-else >
    Please choose a template to preview
  </v-card-text>

  <v-dialog v-model="customiseDialog" fullscreen persistent >
    <notification-configuration
      v-if="customiseDialog"
      v-model='notification'
      :slug='slug'
      :prefix='config.prefix'
      :items='sections'
      :touch="touch"
      @updated='get()'
      @close="customiseDialog=false" />
  </v-dialog>


</v-card>
</template>
<script>
import RevertToDefault from './RevertToDefault.vue'
import NotificationForm from '@/components/actions/forms/NotificationForm.vue'
import PreviewSettings from '@/components/ui/notifications/PreviewSettings.vue'
import {mapGetters} from 'vuex'
import {SECTIONS} from './sections.js'
import NotificationConfiguration from './NotificationConfiguration.vue'
import Vue from 'vue'


export default {
  name: 'NotificationView',
  components: {
    NotificationForm,
    PreviewSettings,
    NotificationConfiguration,
    RevertToDefault
  },
  props: {
    slug: {type: String, required: true},
    spaceId: { required: false }
  },
  data () {
    return {
      activeTab: 0,
      notification: null,
      customiseDialog: false,
      previewSettings: {},
      touch: 0,
      window: 0,
      req: {
        resource: 'ag.practitioner.notifications',
        extra: 'preview',
        status: 0
      },
      slugConfig: {
        inform_practioner_new_appointment: {
          prefix: 'New appointment received: '
        },
        appointment_confirmation_message: {
          prefix: 'Confirming your appointment: '
        },
        appointment_reminder: {
          prefix: 'A friendly reminder about your appointment tomorrow: '
        },
        notify_client_reschedule: {
          prefix: 'Appointment rescheduled: '
        },
        notify_client_cancellation: {
          prefix: 'Appointment cancelled: '
        }
      }
    }
  },
  watch: {
    slug: {
      immediate: true,
      handler () {
        this.get()
      }
    },
    requestStatus () {
      if (this.requestStatus === 200) {
        this.notification = this.req.result
      }
    },
    customiseDialog () {
      if (this.customiseDialog === false) {
        this.get()
      }
    }
  },
  computed: {
    ...mapGetters('identity', ['getProductById', 'meId']),
    previewProduct () {
      if (this.previewSettings && this.previewSettings.product) {
        return this.getProductById(this.previewSettings.product)
      }
      return null
    },
    requestStatus () {
      return this.req.status
    },
    messageLength () {
      if (this.notification && this.notification.preview_formatted) {
        return this.notification.preview_short.length
      }
      return 0
    },
    config () {
      if (this.slug) {
        return this.slugConfig[this.slug]
      }
      return {}
    },
    sections () {
      if (this.slug) {
        let sections = SECTIONS.filter((section) => {
          if (section.context.indexOf(this.slug) >= 0) {
            return section
          }
        })
        let lookup = 'configuration.message'
        if (this.notification && this.notification.type === 'SMS') { lookup = 'configuration.short' }
        let config = this.getObjectPath(this.notification, lookup, [])
        config.forEach((customization) => {
          let section = sections.find((s) => { return s.id === customization.id })
          if (section) {
            section.content = customization.content
            Vue.set(section, 'content', customization.content)
            if (customization.selected) {
              Vue.set(section.selected, this.notification.type, customization.selected[this.notification.type])
            }
          }
        })
        return sections
      }
      return []
    }
  },
  methods: {
    get (previewSettings) {
      this.req.resourceId = this.slug
      this.req.params = previewSettings
      this.$request('get', this.req)
    },
    notificationSaved (notification) {
      this.window = 0
      this.notification = notification
      this.get()
    },
    setEdit () {
      this.window = 1
    },
    setCusomize () {
      this.customiseDialog = true
      this.touch++
    }
  }
}
</script>
